import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {InsolesProviderModelModel} from "../../../api/entity/insolesProviderModel.model";
import {InsolesProviderModelConverter} from "../../../api/entity/insolesProviderModel.converter";
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";
@Injectable({
        providedIn: 'root'
})
export class InsolesProviderModelDataService extends AbstractDataServiceV2<InsolesProviderModelModel, InsolesProviderModelConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: InsolesProviderModelConverter) {
        super('InsolesProviderModel', http, httpUrlGenerator, logger, config, converter);
    }
}
